import React from 'react';
import { Empty, Button } from 'antd';

/**
 * EmptyState — 空状态（Ant Design Empty 封装）
 *
 * @param {node|string} description  描述文案
 * @param {node}         action       底部操作按钮区域（React 节点）
 * @param {string}       image        自定义图片 URL
 */
const EmptyState = ({
  description = '暂无数据',
  action,
  image,
}) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '80px 24px',
    }}>
      <Empty
        description={
          <span style={{ color: 'var(--text-tertiary)', fontSize: 14, fontFamily: 'var(--font-sans)' }}>
            {description}
          </span>
        }
        image={
          image || (
            <div style={{
              width: 64,
              height: 64,
              borderRadius: '50%',
              background: 'var(--glass-md)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 28,
              color: 'var(--text-muted)',
            }}>
              ✨
            </div>
          )
        }
        styles={{
          description: { marginTop: 16 },
        }}
      />
      {action && (
        <div style={{ marginTop: 20 }}>
          {action}
        </div>
      )}
    </div>
  );
};

export default EmptyState;
